$(document).ready(function () {
	setTimeout(function () {
		let swiper = document.getElementById('services-slider').swiper;
		swiper.on('slideChange', function (e) {
			let index = e.activeIndex,
				timeArea = document.querySelectorAll('.time-area'),
				div = document.querySelector('div[data-config]'),
				config = div.getAttribute('data-config'),
				jsonObj = JSON.parse(config);

			function comparison(a, b) {
				for (let i = 0; i < a.length; i++) {
					if (a[i].classList.contains('disabled') && b[i] === false) {
						a[i].classList.remove('disabled')
					}
					if ((!a[i].classList.contains('disabled')) && b[i] === true) {
						a[i].classList.add('disabled');
					}
				}
			}

			function getTimesStatus(el, index) {
				let disabled = [];
				for(let item of el[index].dow) {
					for (let i of item.times) {
						disabled.push(i.disabled);
					}
				}
				return disabled;
			}

			let disabled = getTimesStatus(jsonObj, index);
			comparison([...timeArea], disabled);
		});
	}, 1000);
});